import * as React from "react";
import { eBranches } from "sb-helpers";
import { Scoreboards } from "../../../../constants";
export class ServingIndicator extends React.PureComponent {
    render() {
        const onServeTeamClass = this.props.event.score.additionalScores.onServe === this.props.onServe
            ? "rj-ev-list__indicator--serving"
            : "";
        return (Scoreboards[eBranches[this.props.event.sportId]]
            ? React.createElement("span", { className: `${onServeTeamClass} rj-ev-list__indicator`, "data-uat": "span-ev-list-indicator" })
            : "");
    }
}
//# sourceMappingURL=ServingIndicator.js.map